module.exports = __webpack_public_path__ + "img/im1.ac64ee2a.png";